import React from 'react';
import { Navigate } from 'react-router-dom';
import { TalkPresenceProvider } from '../context/TalkPresenceContext';

/**
 * PublicRoute: Only accessible by non-authenticated users.
 * If logged in, redirects to the dashboard.
 */
export const PublicRoute = ({ children }) => {
    const token = localStorage.getItem('token');

    if (token) {
        return <Navigate to="/dashboard" replace />;
    }

    return children;
};

/**
 * ProtectedRoute: Only accessible by authenticated users.
 * If not logged in, redirects to the login page.
 */
export const ProtectedRoute = ({ children }) => {
    const token = localStorage.getItem('token');

    if (!token) {
        return <Navigate to="/login" replace />;
    }

    return <TalkPresenceProvider token={token}>{children}</TalkPresenceProvider>;
};
